import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alpha, useTheme } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';
import Lottie from 'react-lottie';

import { CurrencyInputCustom } from '~/components/CustomInput';
import * as pdvActions from '~/store/modules/pdv/pdv-actions';
import currency from 'currency.js';
import toast from '~/services/toast';

// import { Container } from './styles';

const ModalAcrescimo = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { venda, showModalAcrescimo } = useSelector(state => state.pdv);
  const [valorAcrescimo, setValorAcrescimo] = useState(venda?.valorAcrescimo);
  const [percentualAcrescimo, setPercentualAcrescimo] = useState(venda?.percentualAcrescimo);

  const changeAcrescimo = e => {
    const acrescimo = e.floatvalue;

    const percentual = Number(
      currency((acrescimo / venda?.valorMercadoria) * 100, {
        precision: 2
      })
    );

    setValorAcrescimo(acrescimo);
    setPercentualAcrescimo(percentual);
  };

  const changeAcrescimoPercentual = e => {
    const percentual = e.floatvalue;

    const acrescimo =
      percentual > 0
        ? Number(
            currency(venda?.valorMercadoria * (percentual / 100), {
              precision: 2
            })
          )
        : 0;
    setValorAcrescimo(acrescimo);
    setPercentualAcrescimo(percentual);
  };

  const handleSubmit = async () => {

    if (venda?.parcelas?.length > 0){
    const { isConfirmed } = await toast.confirm(
      'Deseja alterar a forma de efetuar os pagamentos?',
      'Ao adicionar um acréscimo, irá remover os pagamentos anteriores',
      {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }
    );

    if (isConfirmed) {
      dispatch(pdvActions.limparPagamentos());
      dispatch(pdvActions.selecionarMeioPagamento(null));
      dispatch(pdvActions.selecionarCondicaoPagamento(null));
      dispatch(pdvActions.setMultiplosPagamentos(false));
      dispatch(pdvActions.atualizarAcrescimo(valorAcrescimo));
      handleClose();
    }
    } else {
      dispatch(pdvActions.atualizarAcrescimo(valorAcrescimo));
      handleClose();
    }
  };

  const handleClose = () => {
    dispatch(pdvActions.setShowModalAcrescimo({ show: false }));
  };

  return (
    <>
      <Mui.Dialog
        open={showModalAcrescimo?.show}
        onKeyDown={key => {
          if (key.code === 'Escape') {
            handleClose();
          }
        }}
        PaperComponent={Paper}
        maxWidth={'md'}
      >
        <Mui.DialogTitle>
          <Mui.AppBar color="primary" position="static">
            <Mui.Toolbar>
              <Mui.Box>
                <Mui.Typography variant="h5" style={{ textTransform: 'upperCase' }}>
                  ACRÉSCIMO
                </Mui.Typography>
              </Mui.Box>
              <Mui.Box flexGrow={1} />

              <Mui.IconButton color="inherit" onClick={handleClose} aria-label="close">
                <MuiIcons.Close />
              </Mui.IconButton>
            </Mui.Toolbar>
          </Mui.AppBar>
        </Mui.DialogTitle>
        <Mui.DialogContent dividers style={{ maxWidth: 480 }}>
          <Mui.Box p={2} mb={2}>
            <Mui.Grid container spacing={2}>
              <Mui.Grid item md={7}>
                <Mui.Typography align="left" variant="caption">
                  Acréscimo (R$)
                </Mui.Typography>
                <Mui.TextField
                  value={valorAcrescimo ?? 0}
                  onChange={changeAcrescimo}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: <Mui.InputAdornment position="start">R$</Mui.InputAdornment>,
                    inputComponent: CurrencyInputCustom,
                    style: {
                      height: 54
                    }
                  }}
                />
              </Mui.Grid>
              <Mui.Grid item md={5}>
                <Mui.Typography align="left" variant="caption">
                  Acrésc.(%)
                </Mui.Typography>
                <Mui.TextField
                  value={percentualAcrescimo ?? 0}
                  onChange={changeAcrescimoPercentual}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    inputComponent: CurrencyInputCustom,
                    style: {
                      height: 54
                    }
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Box>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Button size="large" onClick={handleSubmit} variant="contained" color="primary">
            <MuiIcons.CheckCircle /> <span style={{ paddingLeft: 8 }}>CONFIRMAR</span>
          </Mui.Button>

          <Mui.Button startIcon={<MuiIcons.Close />} size="large" onClick={handleClose}>
            CANCELAR (ESC)
          </Mui.Button>
        </Mui.DialogActions>
      </Mui.Dialog>
    </>
  );
};

export default ModalAcrescimo;
